import React from 'react'
import useReveal, { revealClass } from '../hooks/useReveal'

// El desfase se calcula con un módulo para que las fotos que entran juntas se
// encadenen entre sí: si acumulara el índice, en una galería de 20 fotos las
// últimas arrastrarían casi dos segundos de espera.
const RevealImage = ({src, alt, index = 0, className = ''}) => {
  const [ref, visible] = useReveal()

  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      style={{transitionDelay: `${(index % 3) * 90}ms`}}
      className={`${className} ${revealClass(visible)}`}
    />
  )
}

export default RevealImage
